import { RewardsLayout } from './layout'
import { RewardsRoutes } from './routes'
import { RewardsTab } from './tab'

export const RewardsNavigation = {
  Layout: RewardsLayout,
  Routes: RewardsRoutes,
  Tab: RewardsTab,
}
